// @repletoryreach/sdk-utils/whatsapp-text: the same body, as plain text.
//
// A one-line preview in a queue or a picker must not carry bold in it: half a
// bold phrase clipped by an ellipsis looks like a rendering fault, and the
// markers themselves ("*Continue setting up your account*") look like the bug
// this module exists to fix. So the preview runs the same parser and keeps only
// the words.

import { parseWhatsAppText, type ParseOptions, type WaNode } from './parse.js';

function walk(nodes: WaNode[], out: string[]): void {
  for (const n of nodes) {
    switch (n.type) {
      case 'text': out.push(n.value); break;
      case 'code': case 'codeblock': out.push(n.value); break;
      // The shortened label, not the 200-character address: a preview has one
      // line and the reader gains nothing from the query string.
      case 'link': out.push(n.text); break;
      default: walk(n.children, out); break;
    }
  }
}

/** A body with its formatting markers removed and its line breaks kept. */
export function whatsAppPlainText(input: string | null | undefined, opts: ParseOptions = {}): string {
  const out: string[] = [];
  walk(parseWhatsAppText(input, opts), out);
  return out.join('');
}

/**
 * One line of a body for a list row or a picker: markers gone, line breaks and
 * runs of spaces collapsed to single spaces, cut to `maxChars` on a word where
 * one is near enough.
 */
export function whatsAppPreview(input: string | null | undefined, maxChars = 120, opts: ParseOptions = {}): string {
  const flat = whatsAppPlainText(input, opts).replace(/\s+/g, ' ').trim();
  if (flat.length <= maxChars) return flat;
  const cut = flat.slice(0, maxChars - 1);
  const space = cut.lastIndexOf(' ');
  return `${(space > maxChars * 0.6 ? cut.slice(0, space) : cut).trimEnd()}…`;
}
